import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import Util from './axios'
import Qs from 'qs'

import './styles/quasar.styl'
import 'quasar/dist/quasar.ie.polyfills'
import iconSet from 'quasar/icon-set/fontawesome-v5.js'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import Quasar from 'quasar'
import zh from 'quasar/lang/zh-hans'

Vue.use(Quasar, {
    config: {},
    iconSet: iconSet,
    lang: zh,
})

// Vue.config.devtools = true
Vue.config.productionTip = false

Vue.prototype.$http = Util.http; //不指定url
Vue.prototype.$axios = Util.ajax;
Vue.prototype.$qs = Qs;



var contentType = ['application/x-www-form-urlencoded', 'application/json', 'multipart/form-data', ];

Vue.prototype.$ajax = function(type, method, token, url, data) {
    url = AS_ROOT + url; //url.indexOf('login')!==-1?BASE_URL+':8080/dmas/v1/cms'+url:
    var key = localStorage.getItem("AS_token") ? unescape(localStorage.getItem("AS_token")) : null;
    if (!key && token) return new Promise((resolve, reject) => { return reject(false) });
    // if(token) Vue.prototype.$axios.defaults.headers.Authorization = key;
    if (token) Vue.prototype.$axios.defaults.headers.Authorization = token === true ? key : token;
    if (method == 'get') {
        return new Promise((resolve, reject) => {
            Vue.prototype.$axios.get(url, Vue.prototype.$qs.stringify(data, { allowDots: true }), {
                "headers": {
                    'dataType': 'json',
                }
            }).then((res) => {
                return res && res.data && (res.data.success || res.data.code == 20000) ? resolve(res.data) : reject(res.data);
            }).catch((err) => {
                return reject(err.toString());
            });
        });
    } else if (method == 'post' && (!token || type === 0)) {
        return new Promise((resolve, reject) => {
            Vue.prototype.$axios.post(url, Vue.prototype.$qs.stringify(data, { allowDots: true }), {
                "headers": {
                    'dataType': 'json',
                }
            }).then((res) => {
                return res && res.data && (res.data.success || res.data.code == 20000) ? resolve(res.data) : reject(res.data);
            }).catch((err) => {
                return reject(err.toString());
            });
        });
    } else if (method == 'post' && token && type === 1) {
        return new Promise((resolve, reject) => {
            Vue.prototype.$axios.post(url, JSON.stringify(data), {
                "headers": {
                    'dataType': 'json',
                    'Content-Type': 'application/json',
                }
            }).then((res) => {
                return res && res.data && (res.data.success || res.data.code == 20000) ? resolve(res.data) : reject(res.data);
            }).catch((err) => {
                return reject(err.toString());
            });
        });
    } else if (method == 'post' && token && type === 2) {
        return new Promise((resolve, reject) => {
            Vue.prototype.$axios.post(url, data, {
                "headers": {
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json, text/javascript,'
                }
            }).then((res) => {
                return res && res.data && (res.data.success || res.data.code == 20000) ? resolve(res.data) : reject(res.data);
            }).catch((err) => {
                return reject(err.toString());
            });
        });
    } else if (method == 'put') {
        return new Promise((resolve, reject) => {
            Vue.prototype.$axios.put(url, JSON.stringify(data), {
                "headers": {
                    'dataType': 'json',
                    'Content-Type': 'application/json',
                }
            }).then((res) => {
                return res && res.data && (res.data.success || res.data.code == 20000) ? resolve(res.data) : reject(res.data);
            }).catch((err) => {
                return reject(err.toString());
            });
        });
    } else if (method == 'delete') {
        return new Promise((resolve, reject) => {
            Vue.prototype.$axios.delete(url, {
                "data": JSON.stringify(data),
                "headers": {
                    'dataType': 'json',
                    'Content-Type': 'application/json',
                }
            }).then((res) => {
                return res && res.data && (res.data.success || res.data.code == 20000) ? resolve(res.data) : reject(res.data);
            }).catch((err) => {
                return reject(err.toString());
            });
        });
    } else {
        return new Promise((resolve, reject) => {
            return reject('请求错误！');
        });
    }
};

var notifys = [{ type: 'primary', icon: 'fa fa-info fa-lg' }, { type: 'positive', icon: 'fa fa-check fa-lg' }, { type: 'red', icon: 'fa fa-exclamation-triangle fa-lg' }];
Vue.prototype.$notify = function(type, msg, pos) {
    pos = pos ? pos : 'top-right';
    Vue.prototype.$q.notify({
        color: notifys[type].type,
        icon: notifys[type].icon,
        position: pos,
        message: msg,
        timeout: 1800
    })
}

Vue.prototype.$alert = function(msg) {
    Vue.prototype.$q.dialog({
        title: this.$t('msg.prompt'),
        message: msg,
        preventClose: true
    })
}



router.beforeEach((to, from, next) => {
    //Vue.prototype.$q.loadingBar.start()
    var title = 'DESIGNMAN';
    if (localStorage.getItem('lang') == 'zh') {
        title = '应用服务后台';
    } else if (localStorage.getItem('lang') == 'en') {
        title = 'Application Service';
    } else if (localStorage.getItem('lang') == 'ru') {
        title = 'Cлужба приложений';
    }
    Util.title(title); //to.meta.title
    next();
});

router.afterEach(() => {
    //Vue.prototype.$q.loadingBar.stop()
    window.scrollTo(0, 0);
});


new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')